import Dagre from "@dagrejs/dagre";
import { Paths } from "./Paths";
import { BaseNode } from "./BaseNode";
import { FlowWrapper } from "./Wrapper";
import "./Flujo.css";

interface MyFlowProps {
	readonly nodes: BasicNode[];
	readonly edges: Array<[string, string]>;
	readonly selectedId: string | null;
	readonly onNodeClick: (nodeId: string, event: React.MouseEvent) => void;
	readonly onPaneClick: (event: React.MouseEvent) => void;
}
export function MyFlow(props: MyFlowProps) {
	const { nodes, edges } = getLayoutedElements(props.nodes, props.edges);
	const { width, height } = dimensions(nodes);
	return (
		<FlowWrapper width={width} height={height} onPaneClick={props.onPaneClick}>
			<Paths
				edges={edges}
				nodes={nodes}
				width={width}
				height={height}
			/>
			<div className="nodes">
				{nodes.map((node) => (
					<BaseNode
						key={node.id}
						node={node}
						selected={node.id === props.selectedId}
						onClick={props.onNodeClick}
					/>
				))}
			</div>
		</FlowWrapper>
	);
}


interface BasicNode {
	readonly id: string;
	readonly label: string;
	readonly node: React.ReactNode;
	readonly size: { width: number; height: number; };
}
export interface Node extends BasicNode {
	readonly position: { x: number; y: number; };
}
export interface Edge {
	readonly id: string;
	readonly source: string;
	readonly target: string;
}

function getLayoutedElements(nodes: BasicNode[], edges: Array<[string, string]>) {
	const g = new Dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
	g.setGraph({
		rankdir: "LR",
		edgesep: 0,
		ranksep: 50,
		nodesep: 50,
	});

	nodes.forEach((node) => g.setNode(node.id, node.size));
	edges.forEach((edge) => g.setEdge(edge[0], edge[1]));

	// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
	Dagre.layout(g);

	//Add ids for react keys
	const finalEdges = edges.map((edge) => ({
		id: `${edge[0]}-${edge[1]}`,
		source: edge[0],
		target: edge[1],
	}));

	// Shift position from center--centerto top-left
	const finalNodes = nodes.map((node) => {
		const position = g.node(node.id) as {
			x: number;
			y: number;
			width: number;
			height: number;
		};
		return {
			...node,
			position: {
				x: position.x - position.width / 2,
				y: position.y - position.height / 2,
			},
		};
	});

	return {
		nodes: finalNodes,
		edges: finalEdges,
	};
}


function dimensions(nodes: Node[]) {
	const width = nodes.reduce(
		(max, { position, size }) => Math.max(max, position.x + size.width),
		0,
	);
	const height = nodes.reduce(
		(max, { position, size }) => Math.max(max, position.y + size.height),
		0,
	);
	return { width, height };
}
